import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Flex, Strong, Text } from '@radix-ui/themes';
import { useDispatch, useSelector } from 'react-redux';
import { setUserSelectedLocal, selectDevice } from 'store/slices/common';
import { localList } from 'app/constants';

import LocalSort from 'components/common/localSort';
import BoardSearchBox from 'components/board/boardSearchBox';
import { ListType } from 'components/board/boardTextItems';
import Pagination from 'components/common/pagination';
import NoData from 'components/common/noData';
import Loading from 'components/common/loading'; // Loading 컴포넌트 import

export default function BoardList({ tableHeader, localFilter, tableBody, loading, title }) {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  // hooks
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  // 지역 선택 method
  const setRegion = region => {
    searchParams.set('page', 1);
    searchParams.set('searchType', '');
    searchParams.set('search', '');
    setSearchParams(searchParams);
    dispatch(setUserSelectedLocal(localList.find(local => local.code === region).name));
  };

  // 페이지 이동 method
  const handlePageChange = pageNo => {
    const totalPages = tableBody?.pagination.totalPage;
    if (pageNo >= 1 && pageNo <= totalPages) {
      searchParams.set('page', pageNo);
      setSearchParams(searchParams);
    }
  };

  // 검색 method
  const getSearchText = ({ type, text }) => {
    searchParams.set('page', 1);
    searchParams.set('searchType', type);
    searchParams.set('search', text);
    setSearchParams(searchParams);
  };

  return (
    <>
      {localFilter && <LocalSort setRegion={setRegion} />}
      <Box className="board-list">
        <Flex
          direction={isMobile && 'column'}
          justify="between"
          align={!isMobile && 'center'}
          mt={isMobile ? 'var(--space-8)' : 'var(--space-12)'}
          className="search-box-wrap"
        >
          <Text className="board-counter">
            Total : <Strong>{tableBody?.pagination.totalCount?.toLocaleString()}</Strong>건
          </Text>
          <Flex
            wrap={isMobile && 'wrap'}
            justify={!isMobile && 'end'}
            align={!isMobile && 'center'}
            gap="var(--space-2)"
            className="board-search-box"
          >
            <BoardSearchBox getSearchText={getSearchText} />
          </Flex>
        </Flex>

        {loading ? (
          <Loading style={{ height: '800px' }} />
        ) : tableBody?.pagination?.totalCount > 0 ? (
          <>
            <Box mt="var(--space-4)">
              <ListType totalCount={tableBody?.pagination.totalCount} tableHeader={tableHeader} tableData={tableBody.list} title={title} />
            </Box>
            <Flex align={isMobile && 'center'} justify="center" mt={isMobile ? 'var(--space-4)' : 'var(--space-12)'}>
              <Pagination total={tableBody?.pagination.totalPage} handlePageChange={handlePageChange} />
            </Flex>
          </>
        ) : (
          <NoData />
        )}
      </Box>
    </>
  );
}
